<template>
  <span v-bind="$attrs">{{ frame }}</span>
</template>
<script lang="ts" setup>
const frames = ['⠋', '⠙', '⠹', '⠸', '⠼', '⠴', '⠦', '⠧', '⠇', '⠏'];
const speedMs = 80;

const frame = ref(frames[0]);
let i = 0;
let intervalId: number | undefined;

onMounted(() => {
  intervalId = window.setInterval(() => {
    frame.value = frames[i];
    i = (i + 1) % frames.length;
  }, speedMs);
});

onBeforeUnmount(() => {
  if (intervalId !== undefined) clearInterval(intervalId);
});
</script>
